import { ITableColumn } from '@makyoapp/makyo-sdk/models/Table'

import { Cell, ICell } from '.'

interface IRatingColor {
  dark: string
  light: string
}

export interface IRatingColumnSettings {
  ratingColor: IRatingColor
  ratingColorCol: IRatingColor
  ratingIcon: string
  ratingIncrement: string
  ratingMax: number
  ratingMin: number
}

const defaultRatingSettings: IRatingColumnSettings = {
  ratingColor: {
    dark: '#FFBC0B',
    light: '#FFBC0B',
  },
  ratingColorCol: {
    dark: '',
    light: '',
  },
  ratingIcon: 'star',
  ratingIncrement: 'half',
  ratingMax: 5,
  ratingMin: 0,
}

export interface IRatingColumn extends ITableColumn {
  Settings: IRatingColumnSettings
}

export interface IRatingCell extends ICell {
  settings: IRatingColumnSettings
}

export class RatingCell implements IRatingCell {
  value: Cell
  settings: IRatingColumnSettings

  constructor(value: Cell, settings: IRatingColumnSettings) {
    this.value = value
    this.settings = {
      ...defaultRatingSettings,
      ratingColor: settings.ratingColor,
      ratingColorCol: settings.ratingColorCol,
      ratingIcon: settings.ratingIcon,
      ratingIncrement: settings.ratingIncrement,
      ratingMax: settings.ratingMax,
      ratingMin: settings.ratingMin,
    }
  }

  toString(): string {
    const { ratingMax, ratingMin } = this.settings

    // Handle invalid or out-of-range values
    if (typeof this.value !== 'number' || this.value < ratingMin || this.value > ratingMax) {
      return ''
    }

    // Calculate the number of icons to display
    const numberOfIcons = Math.round(((this.value - ratingMin) / (ratingMax - ratingMin)) * 5) // Assuming a 5-star rating system

    return numberOfIcons.toString()
  }

  toCell<T extends Cell>(value: T) {
    this.value = value
    return this
  }
}
